import { api } from "../api";
import { logoApp } from "../iconos";
import type { Sesion } from "../../lib/types";

export function renderLogin(contenedor: HTMLElement, alEntrar: () => void): void {
  // Si el usuario fue desplazado por un login del mismo usuario en otro lado,
  // api.ts dejo este flag antes de recargar: mostramos un aviso.
  const desplazado = sessionStorage.getItem("sesionCerrada") === "1";
  sessionStorage.removeItem("sesionCerrada");

  contenedor.innerHTML = `
    <div class="mx-auto mt-20 max-w-sm">
      <div class="tarjeta">
        <div class="mb-1 flex items-center gap-2 text-2xl font-bold text-masa-900">
          ${logoApp("h-10 w-10")} PediPan
        </div>
        <p class="mb-5 text-sm text-masa-500">Ingresa para tomar pedidos.</p>
        ${desplazado ? `<p class="mb-4 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">Tu sesion se cerro porque se inicio sesion con este usuario en otro dispositivo.</p>` : ""}
        <form id="f" class="space-y-3">
          <label><span class="etiqueta">Usuario</span>
            <input id="usuario" class="campo" autocomplete="username"
                   autocapitalize="none" autocorrect="off" spellcheck="false" /></label>
          <label><span class="etiqueta">Clave</span>
            <input id="clave" type="password" class="campo" autocomplete="current-password" /></label>
          <p id="err" class="text-sm text-red-600"></p>
          <button class="btn-primario w-full">Entrar</button>
        </form>
      </div>
    </div>`;

  const form = contenedor.querySelector("#f") as HTMLFormElement;
  const err = contenedor.querySelector("#err") as HTMLElement;

  form.addEventListener("submit", async (ev) => {
    ev.preventDefault();
    err.textContent = "";
    const usuario = (contenedor.querySelector("#usuario") as HTMLInputElement).value.trim();
    const clave = (contenedor.querySelector("#clave") as HTMLInputElement).value;
    try {
      await api.post<Sesion>("/api/login", { usuario, clave });
      alEntrar();
    } catch (e) {
      err.textContent = e instanceof Error ? e.message : "No se pudo ingresar";
    }
  });
}
